import { FieldValue, Timestamp } from "firebase/firestore";
import {
  NewVehicleControl,
  PutVehicleControl,
} from "../../domain/control/Vehicle";
import { isNil } from "lodash";
import { formatDateAsTime } from "../../util/date";
import { ignoreNil, undefinedToNull } from "../../util/object";

export type GetVehicleControlDto = {
  driver?: string;
  departure?: string;
  derivation?: string;
  destination?: string;
  entry?: string;
  guide?: string;
  license?: string;
  observation?: string;
  ownerUid: string;
  plate?: string;
  ramp?: string;
  timestamp: Timestamp;
  unityId?: number | string;
};

export type PostVehicleDto = {
  ownerUid: string;
  unityId: number;
  entry: string;
  departure?: string;
  driver: string;
  plate: string;
  license: string;
  derivation?: string;
  guide?: string;
  dni?: string;
  destination?: string;
  ramp?: string;
  observation?: string;
  platePhoto?: string;
  timestamp: FieldValue;
};

export type PutVehicleDto = {
  departure?: string | null;
  observation?: string | null;
};

export type VehicleListQueryRequest = {
  orderBy: keyof GetVehicleControlDto;
  order: "asc" | "desc";
};

export const newVehicleControlAsDto: (
  c: NewVehicleControl
) => Partial<PostVehicleDto> = (newControl) =>
  undefinedToNull({
    ...newControl,
    timestamp: Timestamp.now(),
    entry: formatDateAsTime(newControl.entry),
    departure: !isNil(newControl.departure)
      ? formatDateAsTime(newControl.departure)
      : null,
  });

export const putVehicleControlAsDto: (
  c: PutVehicleControl
) => Partial<PutVehicleControl> = (putControl) =>
  undefinedToNull({
    ...putControl,
    departure: !isNil(putControl.departure)
      ? formatDateAsTime(putControl.departure)
      : null,
  });
